export const mapStyles: google.maps.MapTypeStyle[] = [];
